import * as createHistory from "history";

export default createHistory.createBrowserHistory();
